import React from 'react';
// import { HelpBlock } from '@package/components';

const AfterRelatedItems = ({ content }) => {
  // return <HelpBlock />;
  return <></>;
};
export default AfterRelatedItems;
